/* A soft, Cannafax-own arrival chime: two warm sine notes synthesized with Web Audio
   (no asset, not an OS sound). Plays once per arrival — never repeats or nags.
   A short global cooldown collapses bursts and duplicate listeners into one ding. */

let ctx: AudioContext | null = null;
let lastPlayed = 0;
const COOLDOWN_MS = 4000;

function getCtx(): AudioContext | null {
  try {
    if (!ctx) {
      const AC = window.AudioContext || (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
      if (!AC) return null;
      ctx = new AC();
    }
    return ctx;
  } catch {
    return null;
  }
}

/** Unlock audio on the first user gesture so later arrivals can play. */
if (typeof window !== 'undefined') {
  const unlock = () => {
    const c = getCtx();
    void c?.resume().catch(() => {});
    window.removeEventListener('pointerdown', unlock);
    window.removeEventListener('keydown', unlock);
  };
  window.addEventListener('pointerdown', unlock);
  window.addEventListener('keydown', unlock);
}

function note(c: AudioContext, freq: number, start: number, dur: number, peak: number) {
  const osc = c.createOscillator();
  const gain = c.createGain();
  osc.type = 'sine';
  osc.frequency.value = freq;
  gain.gain.setValueAtTime(0.0001, start);
  gain.gain.exponentialRampToValueAtTime(peak, start + 0.02);
  gain.gain.exponentialRampToValueAtTime(0.0001, start + dur);
  osc.connect(gain).connect(c.destination);
  osc.start(start);
  osc.stop(start + dur + 0.05);
}

export function playNotificationChime() {
  const now = Date.now();
  if (now - lastPlayed < COOLDOWN_MS) return;
  if (typeof document !== 'undefined' && document.visibilityState === 'hidden') return;
  const c = getCtx();
  if (!c || c.state !== 'running') return;
  lastPlayed = now;
  const t = c.currentTime;
  note(c, 659.25, t, 0.35, 0.12); // E5
  note(c, 987.77, t + 0.12, 0.55, 0.09); // B5
}
